import { Injectable, signal } from '@angular/core';
import { Subject } from 'rxjs';

import { ToastType } from '../components/ui/toast/toast.component';

export interface ToastPayload {
  type: ToastType;
  message: string;
  instruction?: string;
  persistent?: boolean;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly subject = new Subject<ToastPayload>();
  private readonly clearSubject = new Subject<void>();
  readonly toasts$ = this.subject.asObservable();
  readonly clear$ = this.clearSubject.asObservable();

  // signal-based latest payload (null when none)
  readonly latest = signal<ToastPayload | null>(null);

  show(type: ToastType, message: string, instruction?: string, persistent?: boolean) {
    const payload: ToastPayload = { type, message, instruction, persistent };
    // debug log to help trace toast emissions
    console.debug('[ToastService] show', payload);
    this.subject.next(payload);
    this.latest.set(payload);
  }

  success(message: string, instruction?: string, persistent?: boolean) {
    this.show('success', message, instruction, persistent);
  }

  error(message: string, instruction?: string, persistent?: boolean) {
    this.show('error', message, instruction, persistent);
  }

  clear() {
    this.latest.set(null);
    this.clearSubject.next();
  }
}
